<template>
  <div v-wechat-title="$route.meta.title">
    <div class="cont">
      <!-- 搜索 -->
      <div class="search">
        <img @click="back" src="../assets/img/back.png" />
        <div class="searchCont">
          <van-row class="vin-bar" type="flex" justify="space-between">
            <van-col class="dropdown-box" span="6">
              <van-dropdown-menu active-color="#4FAE54">
                <van-dropdown-item v-model="VinHistoryStore.searchBy" :options="VinHistoryStore.searchOptions" />
              </van-dropdown-menu>
            </van-col>
            <van-col span="18">
              <van-search v-model="keyword" :placeholder="placeholder" @search="search" />
            </van-col>
          </van-row>
        </div>
        <img @click="handleShowModel" src="../assets/shengji/date.png" />
      </div>
      <!-- 列表 -->
      <van-list :finished="finished" finished-text v-model="loading" @load="onLoad">
        <ul class="list" v-if="showList">
          <li v-for="(item, index) of list" @click="toOrderHistory(item)" :key="index">
            <van-row type="flex" justify="space-between">
              <van-col class="car-info" span="24">
                <div>
                  <img src="../assets/shengji/car.png" />
                  车型：{{ item.VehicleType || "无" }}
                  <div v-if="item.Objcount > 0" class="tag-green">
                    <img src="../assets/shengji/flow.png" />
                    累计交易数量：{{ item.Objcount }}
                  </div>
                </div>
              </van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col class="car-info" span="24">
                <div>
                  <img src="../assets/shengji/vin.png" />
                  VIN码：{{ item.vin || "无" }}
                </div>
              </van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col class="car-info" span="24">
                <div>
                  <img src="../assets/shengji/date.png" />
                  最后一次查询日期：{{ item.UpdateTime | timeFormat }}
                </div>
              </van-col>
            </van-row>
          </li>
        </ul>
      </van-list>
      <!-- 数据为空 -->
      <div class="buyBlock" v-if="empty">
        <div class="buyBlockTop">
          <img src="../assets/icon/gouwuche.png" />
          <span class="buyBlockTxt">暂无历史查询</span>
        </div>
      </div>
      <!-- 筛选 -->
      <van-popup position="right" :style="{ width: '85%', height: '100%' }" v-model="modelShow">
        <div class="model">
          <div class="times">
            <div class="it" @click="handleTime(1)">
              <span>{{ queryData.StartTime ? queryData.StartTime : "开始时间" }}</span>
              <img src="../assets/img/time.png" />
            </div>
            <div class="it" @click="handleTime(2)">
              <span>{{ queryData.EndTime ? queryData.EndTime : "结束时间" }}</span>
              <img src="../assets/img/time.png" />
            </div>
          </div>
          <div class="modelBtn">
            <div class="van-hairline--surround" @click="reset">重置</div>
            <div @click="search">查询</div>
          </div>
          <!-- 时间控件 -->
        </div>
      </van-popup>
      <van-popup position="bottom" :style="{ width: '100%', height: '36%' }" v-model="timeShow">
        <van-datetime-picker v-model="currentDate" type="date" :title="timeTitle" @confirm="confirm" @cancel="cancel" />
      </van-popup>
    </div>
  </div>
</template>
<script>
import { DropdownMenu, DropdownItem } from "vant";
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
import Vue from "vue";
import { List, Popup, Search, DatetimePicker, Toast } from "vant";
import api from "../services/api";
import dayjs from "dayjs";
import VinHistoryStore from "../store/vinHistory";
import OrderHistoryStore from "../store/orderHistory";
import vinHistory from "../store/vinHistory";
import orderDetailVue from "./orderDetail.vue";
Vue.use(List)
  .use(Popup)
  .use(Search)
  .use(DatetimePicker);
export default {
  data() {
    return {
      VinHistoryStore,
      OrderHistoryStore,
      keyword: "",

      queryData: {
        SalesOrderCode: "",
        ProductName: "",
        BrandManufacturerCode: "",
        Specifications: "",
        Model: "",
        CustomModel: "",
        StartTime: "",
        EndTime: "",
      },
      modelShow: false,
      timeShow: false,
      timeType: 1,
      currentDate: new Date(),
      timeTitle: "",
    };
  },
  filters: {
    toFixedNum(val) {
      return Number(val).toFixed(2);
    },
    timeFormat(str) {
      if (!str) return "无";

      return dayjs(str).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  computed: {
    list: () => vinHistory.list,
    finished: () => vinHistory.finished,
    placeholder() {
      let it = VinHistoryStore.searchOptions.find((it) => it.value === VinHistoryStore.searchBy);
      return it ? it.placeholder : "输入后检索";
    },
    loading: {
      get: () => vinHistory.loading,
      set: () => {},
    },
    empty() {
      if (!this.loading && this.list.length == 0) {
        return true;
      }
    },
    showList() {
      if (!this.loading && this.list.length > 0) {
        return true;
      }
    },
  },
  created() {},
  methods: {
    onLoad() {
      VinHistoryStore.initList({ keyword: this.keyword });
    },
    search() {
      let StartTime = this.queryData.StartTime;
      let EndTime = this.queryData.EndTime;
      if (StartTime && EndTime) {
        if (!this.compareDate(StartTime, EndTime)) {
          return Toast("开始时间不能大于结束时间!");
        }
      }
      this.modelShow = false;
      VinHistoryStore.initList({ keyword: this.keyword, StartTime, EndTime });
    },
    back() {
      this.$router.go(-1);
    },
    toOrderHistory(item) {
      if (item.Objcount === 0) {
        return;
      }

      OrderHistoryStore.setVinInfo({
        VehicleTypeId: item.VehicleTypeId,
        vin: item.vin,
        VehicleType: item.VehicleType,
      });

      this.$router.push({
        path: `/historicalOrders`,
        query: {
          VehicleTypeId: item.VehicleTypeId,
        },
      });
    },
    // 查询
    handleSearch() {
      this.getOrder();
    },

    handleShowModel() {
      this.modelShow = true;
    },
    handleToOrderDetail(id) {
      this.$router.push(`/orderDetail/${id}`);
    },
    handleTime(type) {
      this.timeType = type;
      this.timeShow = true;
      type === 1 ? (this.timeTitle = "选择开始时间") : (this.timeTitle = "选择结束时间");
    },
    timeFormatYd(str) {
      return dayjs(str).format("YYYY/MM/DD");
    },

    // 比较时间大小
    compareDate(startTime, endTime) {
      return new Date(startTime.replace(/-/g, "\/")) <= new Date(endTime.replace(/-/g, "\/"));
    },
    handleToPage() {
      this.$router.push("/baojia");
    },
    confirm(value) {
      value = this.timeFormatYd(value);
      this.timeType === 1 ? (this.queryData.StartTime = value) : (this.queryData.EndTime = value);
      this.timeShow = false;
      this.currentDate = new Date();
    },
    cancel() {
      this.timeShow = false;
    },
    reset() {
      for (let key in this.queryData) {
        this.queryData[key] = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/historicalOrders.scss";

.list {
  font-size: 0.28rem;
  color: #333333;
  li {
    background: #fff;
    padding: 0.2rem;
    line-height: 0.4rem;
    margin: 0.2rem 0;
    img {
      filter: opacity(0.5);
      height: 0.25rem;
      width: 0.25rem;
      display: inline-block;
      margin-right: 0.1rem;
    }
    .tag-green {
      display: inline-block;
      font-size: 0.2rem;
      padding: 0 0.1rem;
      color: #4fae54;
      background: #e9feea;
      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }
  }
}
.vin-bar > div {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss">
.search .van-field__body .van-field__control {
  text-align: left !important;
}

.dropdown-box .van-dropdown-menu__bar {
  height: 0.98rem;
  box-shadow: none;
}
</style>
